import { useMemo } from "react";
import { useAppContext } from "./appContext";

export function useSnackbar() {
  const { openSnackbar, closeSnackbar } = useAppContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => ({ openSnackbar, closeSnackbar }), []);
}
